import type {
	Abi,
	Address,
	ContractName,
	ValidChainId,
} from "@bracket/chainography/types";

import { chains } from "..";

export const getContractWithABI = <C extends ValidChainId = 1>(
	contract: ContractName<C>,
	chainId: ValidChainId = 1,
	version?: number,
): [Address, Abi] => {
	try {
		if(chainId in chains) {
			const contractName = version ? `${String(contract)}V${version}` : contract;
			if(contractName in chains[chainId].contracts) {
				const {
					address,
					abi,
				} = chains[chainId as number].contracts[contractName];
				return [address, abi];
			}
			throw new Error(`contract "${contract.toString()}" ${version ? `V${version}` : ""} does not exist on chain ${chainId}`);
		}
		throw new Error(`received invalid chainId ${chainId}`);
	}
	catch( err ) {
		throw new Error(`@bracket/chainography::getContractWithAbi failed - ${err.message}`)
	}
};
